
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import {

documentType } from "@/common/js/const";

import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Box from 'vux/src/components/box/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'


export default {

components: {
Group,
Cell,
Box,
CellBox,
XHeader,
XButton,
Swipeout,
SwipeoutItem,
SwipeoutButton,
CheckIcon
},
data() {
return {


invoiceTagMode: false,
invoiceId: "",
tags: [],
helpInfo:'',
};
},
created() {},
activated() {
var $self = this;
var __id = $self.$route.params.id;
if (__id) {
$self.invoiceTagMode = true;
if ($self.invoiceId != __id && __id != null && __id != "") {
$self.invoiceId = __id;
$self.pageLoad(__id);
}
} else {
$self.invoiceTagMode = false;
}
$self.helpInfo = this.$t('标签管理小提示');
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {
...mapState({
STATE_InvoiceTags: state => state.invoice.invoiceInfo.labels
})
},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {
...mapActions({
ACTION_setLabels: "invoice_ac_setInvoiceTags"
}),
/**加载发票票据标签 */
pageLoad(invoiceId) {
var $self = this;
$self.$webapi
.listTagByInvoice({
invoiceId: invoiceId
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
var resData = res.data.result;
$self.tags = resData.map(function(item) {
return {
label: item.labelName,
value: item.id,
selected: item.status == 1 
};
});
$self.tags.sort(function(value1, value2) {
if (value1.value < value2.value) {
return 1;
} else if (value1.value > value2.value) {
return -1;
} else {
return 0;
}
});
}
});
},

createTag() {
var $self = this;
$self.$vux.confirm.prompt(this.$t("请输入标签名"), {
title: this.$t("添加标签"),
confirmText: this.$t("确定"),
cancelText: this.$t("取消"),
inputAttrs: {
type: "text"
},
onShow() {


},
onCancel() {},
onConfirm(newVal) {
if (newVal) {
if (newVal.length > 8) {
$self.$vux.toast.show({
text: $self.$t("标签名称过长"),
type: "text"
});
return false;
}
var exist = $self.tags.some(function(ell) {
return ell.label == newVal;
});
if (exist) {

$self.$vux.toast.show({
text: $self.$t("标签名已存在"),
type: "text"
});
return false;
}
$self.$webapi
.createTag({
labelName: newVal
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.pageLoad($self.invoiceId);
}
});
}
}
});
},

updateTag(tagModel) {
var $self = this;
$self.$vux.confirm.prompt(this.$t("请输入标签名"), {
title: this.$t("编辑标签"),
confirmText: this.$t("确定"),
cancelText: this.$t("取消"),
inputAttrs: {
type: "text"
},
onShow() {

$self.$vux.confirm.setInputValue(tagModel.label);
},
onCancel() {},
onConfirm(newVal) {
if (newVal) {

if (newVal.length > 8) {
$self.$vux.toast.show({
text: $self.$t("标签名称过长"),
type: "text"
});
return false;
}

var exist = $self.tags.some(function(ell) {
return ell.label == newVal && ell.value != tagModel.value;
});
if (exist) {

$self.$vux.toast.show({
text: $self.$t("标签名已存在"),
type: "text"
});
return false;
}

$self.$webapi
.updateTag({
labelId: tagModel.value,
labelName: newVal
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {


tagModel.label = newVal;










}
});
}
}
});
},

deleteTag(tagModel) {
var $self = this;

$self.$webapi
.deleteTag({
labelId: tagModel.value
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {


$self.tags = $self.tags.filter(function(ell) {
return ell.value != tagModel.value;
});







}
});
},
itemClick(el) {
var $self = this;

$self.$webapi
.updateInvoiceTag({
invoiceId: $self.invoiceId,
labelId: el.value,
status: el.selected ? 1 : 0
})
.then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {













}
});
},


onButtonClick(type, el) {
var $self = this;
if (type == "edit") {
$self.updateTag(el);
}

if (type == "delete") {
$self.deleteTag(el);
}

},
pageGoBack(){
this.$router.push(localStorage.getItem('forwardPath'));
}
}
};
